import CustomerAuthForm from "../auth/CustomerAuthForm";

export default function LoginForm() {
    return <CustomerAuthForm />;
}
